<div class="prd-complete-container">
  <!-- ============================================ -->
  <!-- SECCIÓN 1: LIFE-CIRCLE / ANÁLISIS PROFUNDO  -->
  <!-- ============================================ -->
  
  <div class="life-circle-section">
    <div class="container">
      <!-- Main View -->
      <div>
        <!-- Header with breadcrumb -->
        <div class="header-row">
          <div class="header-left">
            <span class="breadcrumb">Plan de Vida > <span class="breadcrumb-active">Priorización</span></span>
          </div>
        </div>

        <!-- Main content -->
        <div class="main-content">
          <!-- Page Header -->
          <div class="page-header">
            <h1 class="page-title">Priorización</h1>
            <p class="page-description">Clasifica cada área como Alta, Media o Baja prioridad, según lo que tú consideres importante trabajar hoy, en el presente.</p>
          </div>
          
          <!-- Save Button -->
          <div class="save-section" *ngIf="!priorizacionCompleted">
            <button class="btn-save" (click)="savePriorities()">
              {{ allPrioritiesSelected ? 'Finalizar' : 'Guardar' }}
            </button>
          </div>

          <!-- Completion Message -->
          <div class="completion-message" *ngIf="priorizacionCompleted">
            <div class="completion-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="completion-text">
              <h3>¡Priorización Completada!</h3>
              <p>Has finalizado exitosamente la priorización de todas las áreas. Tus prioridades han sido guardadas.</p>
            </div>
          </div>

          <!-- Priority Legend -->
          <div class="priority-legend">
            <p class="legend-item"><b>Alta</b> (Quiero trabajarlo ahora, es prioritario)</p>
            <p class="legend-item"><b>Media</b> (Es importante, pero no urgente.)</p>
            <p class="legend-item"><b>Baja</b> (No es relevante en este momento.)</p>
          </div>
        </div>

        <!-- Tests List -->
        <div class="tests-list">
          <div class="test-item" *ngFor="let test of tests" [ngClass]="{'completed': test.progress === 100}">
            <div class="test-content">
              <div class="test-title">
                <span class="test-number">{{getTestNumber(test)}}</span>
                <span class="test-name">{{test.dimensions[0].area.name}}</span>
                <button *ngIf="test.progress === 100" class="btn-matrices" (click)="toggleDimensionMatrices(getTestId(test))">
                  <i class="fas" [ngClass]="isDimensionExpanded(getTestId(test)) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </div>
            </div>
            
            <!-- Matrices de resultados individuales para cada dimensión -->
            <div *ngIf="test.progress === 100 && isDimensionExpanded(getTestId(test))" class="dimension-matrices">
              <div class="matrix-content">
                <div *ngFor="let dimension of test.dimensions" class="subdimension-matrix">
                  <h4 class="subdimension-title">{{dimension.name}}</h4>
                  <div class="matrix-table-container">
                    <table class="matrix-table">
                      <thead>
                        <tr>
                          <th>Área</th>
                          <th class="hide-mobile">Análisis Presente</th>
                          <th class="hide-mobile">Análisis Futuro</th>
                          <th>Brecha por Cerrar</th>
                          <th>Prioridad</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let question of dimension.questions; let i = index">
                          <td class="area-name">{{i + 1}}. {{question.name}}</td>
                          <td class="analysis-value hide-mobile">{{question.answer.valueNow || 0}}</td>
                          <td class="analysis-value hide-mobile">{{question.answer.valueFuture || 0}}</td>
                          <td class="gap-cell">
                            <span class="gap-badge" [ngClass]="getGapClass(calculateGap(question))">
                              {{calculateGap(question)}}
                            </span>
                          </td>
                          <td class="priority-cell">
                            <select 
                              [ngModel]="getQuestionPriority(question)" 
                              (ngModelChange)="updateQuestionPriority(question, $event)"
                              class="priority-select">
                              <option value="">Seleccionar</option>
                              <option value="Alta">Alta</option>
                              <option value="Media">Media</option>
                              <option value="Baja">Baja</option>
                            </select>
                          </td>
                        </tr>
                        <tr class="average-row">
                          <td class="area-name"><strong>Promedio</strong></td>
                          <td class="analysis-value hide-mobile"><strong>{{getAveragePresent(dimension.questions)}}</strong></td>
                          <td class="analysis-value hide-mobile"><strong>{{getAverageFuture(dimension.questions)}}</strong></td>
                          <td class="gap-cell"><strong>{{getAverageGap(dimension.questions)}}</strong></td>
                          <td class="priority-cell"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botón para alternar la sección PRD -->
        <!-- <div *ngIf="areAllDimensionsCompleted()" class="prd-toggle-section">
          <button class="btn-toggle-prd" (click)="togglePRDSection()">
            <i class="fas" [ngClass]="showPRDSection ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ showPRDSection ? 'Ocultar' : 'Ver' }} Priorización (PRD)</span>
          </button>
        </div> -->
      </div>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- SECCIÓN 2: PRD (PRIORIZACIÓN)               -->
  <!-- ============================================ -->
  
  <div class="prd-section" *ngIf="showPRDSection && areAllDimensionsCompleted()">
    <div class="container prd-container">
      <div class="header">
        <div class="left-header">
          <h3 class="section-title">Prioriza, Revisa y Define (PRD)</h3>
          <p>
            El dato de hoy solo sirve como punto de partida para la proyección de 7
            años junto con el cruce de prioridad
          </p>
        </div>
        <div class="actions">
          <button class="btn-agenda" [disabled]="!testsCompletedForPRD" [routerLink]="['/dashboard/mentors']">
            Agenda con tu mentor
          </button>
        </div>
      </div>

      <div [@fade]="messageHide ? 'hidden' : 'visible'" class="message">
        <div class="message-text">
          <span class="message-icon"><i class="fa-solid fa-envelope"></i></span>
          <p>Llena la sección de Prioridad con tu mentor, agenda ahora mismo.</p>
        </div>
        <div class="message-close" (click)="hideMessage()">
          <i class="fa-solid fa-x"></i>
        </div>
      </div>

      <!-- Mensaje de estado de edición -->
      <div class="edit-status-message" *ngIf="isEditingPriority">
        <p>
          <i class="fa-solid fa-pencil"></i> Modo edición activado. Última prioridad
          asignada: {{ lastUsedPriority }}
        </p>
      </div>

      <div class="content">
        <div class="left-table">
          <div class="table-header">
            <div class="dimension-column">Dimensión</div>
            <div class="evaluacion-columns">
              <div class="evaluacion-title">Evaluación</div>
              <div class="evaluacion-subtitles">
                <div>Actual</div>
                <div>Futuro</div>
                <div>Promedio</div>
              </div>
            </div>
            <!-- Columna dinámica para prioridad - cambia según el modo -->
            <ng-container *ngIf="!isEditingPriority">
              <div class="prioridad-column">Prioridad (Y)</div>
            </ng-container>
            <ng-container *ngIf="isEditingPriority">
              <div class="prioridad-anterior-column">Anterior</div>
              <div class="prioridad-column">Prioridad (Y)</div>
            </ng-container>
          </div>

          <div class="table-body">
            <ng-container *ngFor="let test of tests">
              <ng-container *ngFor="let dimension of test.dimensions">
                <div
                  class="table-row"
                  [ngClass]="{
                    highlighted: dimension.name === 'Trabajo y des. personal',
                    'dimension-completed': dimension.completed
                  }"
                >
                  <div class="dimension-name">{{ dimension.name }}</div>
                  <div class="evaluacion-values">
                    <div class="actual-value">
                      {{
                        getAverage(dimension, "now").toFixed(1).replace(".", ",")
                      }}
                    </div>
                    <div class="futuro-value">
                      {{
                        getAverage(dimension, "future").toFixed(1).replace(".", ",")
                      }}
                    </div>
                    <div class="promedio-value">
                      {{
                        (
                          (getAverage(dimension, "now") +
                            getAverage(dimension, "future")) /
                          2
                        )
                          .toFixed(1)
                          .replace(".", ",")
                      }}
                    </div>
                  </div>

                  <!-- Vista normal (no editando) -->
                  <ng-container *ngIf="!isEditingPriority">
                    <div class="prioridad-value">
                      {{ dimension.priority || "-" }}
                    </div>
                  </ng-container>

                  <!-- Vista de edición con columna anterior -->
                  <ng-container *ngIf="isEditingPriority">
                    <!-- Columna que muestra valor anterior -->
                    <div class="prioridad-anterior-value">
                      {{ dimension.priority || "-" }}
                    </div>

                    <!-- Columna con combobox que permite seleccionar CUALQUIER valor -->
                    <div class="prioridad-value">
                      <div class="priority-container" *ngIf="dimension.completed">
                        <select
                          [(ngModel)]="dimension.tempPriority"
                          (ngModelChange)="
                            onTempSelectChange($event, dimension, test._id)
                          "
                          [disabled]="!dimension.completed"
                        >
                          <option value="" selected disabled>-</option>
                          <!-- Aquí mostramos TODAS las opciones sin restricciones -->
                          <option
                            *ngFor="let value of selectOptions"
                            [value]="value"
                          >
                            {{ value }}
                          </option>
                        </select>
                      </div>
                      <div *ngIf="!dimension.completed">-</div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="buttons-container">
            <button
              class="btn-download"
              (click)="downloadPdf()"
              [disabled]="!testsCompletedForPRD"
            >
              Descargar informe en PDF
            </button>
            <button
              class="btn-edit"
              [ngClass]="{ active: isEditingPriority }"
              (click)="toggleEditPriority()"
              [disabled]="!testsCompletedForPRD"
            >
              {{ isEditingPriority ? "Finalizar edición" : "Editar prioridad" }}
            </button>
          </div>
        </div>

        <div class="right-chart">
          <div id="chart"></div>
          <div class="chart-info">
            <p>Evaluación presente y futuro</p>
          </div>
          <div class="priority-info">
            <p>
              Considerar la prioridad 1 como la más importante y la prioridad 10 la
              menos importante.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
